import { ComponentProps, useCallback, useEffect, useRef } from 'react'
import styles from './SourceName.module.scss'
import { Link } from 'react-router-dom';
import { useRandomPosition, IPosition } from '../../hooks/common';
import gsap from 'gsap';

interface ISourceName extends ComponentProps<"a"> {
  sourceId: string
  name: string;
  url: string;
  getParent: () => HTMLElement | null
  positions: Record<string, IPosition>
  setPositions: (pos: Record<string, IPosition>) => void
}

const SourceName = (props: ISourceName) => {
  const { name, url, getParent, sourceId, positions, setPositions } = props

  const sourceNameRef = useRef<HTMLAnchorElement>(null)
  const getCurrent = useCallback(() => {
    return sourceNameRef.current
  }, [sourceNameRef])

  const { top, left } = useRandomPosition(sourceId, positions, setPositions, getParent, getCurrent)

  useEffect(() => {
    const tl = gsap.timeline()
    tl.to(`#source-name-${sourceId}`, {
      top: `${top}px`,
      left: `${left}px`,
      duration: 1
    })
  }, [top, left])

  return (
    <Link
      id={`source-name-${sourceId}`}
      className={styles.sourceName}
      to={url}
      target='_blank'
      ref={sourceNameRef}
    >
      {name}
    </Link>
  )
}

export default SourceName